<template>
  <div style="width: 100%">
    <div class="terminal-content-tab selected" data-tab-body="betting">
      <div class="terminal-body">
        <div class="terminal-game">
          <div class="header-bar main-bar">
            <div
              class="game-progress-lb"
              :style="{ width: `${this.gameProgress}%` }"
            ></div>
            <div
              class="result-progress-lb"
              :style="{ width: `${this.resultProgress}%` }"
            ></div>
            <div class="text-progress">
              <div class="progress-current-round">
                {{ translate("current_game_id") }} {{ currentIdToday }}
              </div>
              <div class="progress-current-time">
                {{
                  this.gameTimer && this.gameTimer > 0
                    ? `${translate("draw_begins_in")} ${
                        this.gameTimer
                      } ${translate("sec")}`
                    : ""
                }}
                {{
                  this.resultTimer && this.resultTimer > 0
                    ? `${translate("next_game_opens_in")}  ${
                        this.resultTimer
                      } ${translate("sec")}`
                    : ""
                }}
              </div>
              <div class="progress-current-status">
                {{
                  this.gameStatus === 0
                    ? translate("open_game_status")
                    : translate("in_progress_game_status")
                }}
              </div>
            </div>
          </div>
          <div class="terminal-balls" v-show="!extraBalls">
            <Balls
              :balls="balls"
              @selectBall="selectBalls"
              @selectColor="selectColors"
            />
            <ExtraBalls
              @randomSix="randomSix"
              @quickRandomSix="quickRandomSix"
              @setAllColors="setAllColors"
              @addBallsToSlip="addBallsToSlip"
              @clearSelectedBallsFromExtraBalls="clearSelectedBalls"
              :selectedNoOfBalls="getSelectedBalls.length"
            />
          </div>
        </div>
        <ExtraGames
          v-show="extraBalls"
          @buyingTicket="buyTicket"
          @setExtraCombinations="setExtraGamesCombinations"
          @addToSlip="addToSlip"
          @removeFromSlip="removeFromSlip"
        />
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import Balls from "./Balls";
import { mapGetters } from "vuex";
import $eventBus from "../../eventBus";
import { translate } from "../../assets/common/lang";
import ExtraBalls from "./ExtraBalls";
import ExtraGames from "./ExtraGames";

export default {
  props: [
    "gameTimer",
    "currentIdToday",
    "resultTimer",
    "gameStatus",
    "gameTimerMax",
    "gameTimerResultMax",
  ],
  data() {
    return {
      maxNoOfSelectedBalls: 10,
      minNumber: 1,
      maxNumber: 48,
      selectedBalls: [],
      combinations: 0,
      extraGamesCombinations: 0,
      extraBalls: false,
      balls: {
        red: [],
        green: [],
        blue: [],
        purple: [],
        brown: [],
        yellow: [],
        orange: [],
        silver: [],
      },
      buyPayload: {},
      lastBuyPayload: {},
    };
  },
  components: {
    Balls,
    ExtraBalls,
    ExtraGames,
  },
  computed: {
    ...mapGetters([
      "getBoughtTicketResp",
      "getMainConfig",
      "getGameConfig",
      "getSelectedBalls",
      "getInternalCombinations",
      "getSlip",
      "getMainCombinations",
    ]),
  },
  methods: {
    async addBallsToSlip(dontClear) {
      let selectedBalls = this.getSelectedBalls;
      if (!selectedBalls.length) {
        return;
      }

      if (
        selectedBalls.length > 10 &&
        selectedBalls.length !== 48 &&
        typeof dontClear === "undefined"
      ) {
        this.clearSelectedBalls();
        return;
      }

      if (!this.getInternalCombinations) {
        this.$bvToast.toast(translate(`chose_some_bets`), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        return;
      }

      let rules = {
        6: 1,
        7: 7,
        8: 28,
        9: 84,
        10: 210,
        48: 8,
      };

      const pattern = [
        1, 9, 17, 25, 33, 41, 2, 10, 18, 26, 34, 42, 3, 11, 19, 27, 35, 43, 4,
        12, 20, 28, 36, 44, 5, 13, 21, 29, 37, 45, 6, 14, 22, 30, 38, 46, 7, 15,
        23, 31, 39, 47, 8, 16, 24, 32, 40, 48,
      ];

      // Create a lookup table for pattern positions
      const patternIndex = pattern.reduce((acc, num, index) => {
        acc[num] = index;
        return acc;
      }, {});

      // Sort selected balls
      if (selectedBalls.length !== 48) {
        selectedBalls.sort((a, b) => a.number - b.number);
      } else {
        // Sort the array based on the pattern
        selectedBalls.sort(
          (a, b) => patternIndex[a.number] - patternIndex[b.number]
        );
      }

      this.addToSlip({
        type: selectedBalls.length === 48 ? "ALLBALLS" : "BALLS",
        name: "",
        id: `B-${selectedBalls
          .map((number) => number.number)
          .join("")}-${String(Math.random())}`,
        value: selectedBalls,
        minBetVal:
          Number(this.getGameConfig.Bingo_MinBetCombination) *
            rules[selectedBalls.length] <
          Number(this.getGameConfig.Bingo_MinBet)
            ? this.getGameConfig.Bingo_MinBet
            : Number(this.getGameConfig.Bingo_MinBetCombination) *
              rules[selectedBalls.length],
      });
    },
    async addToSlip(payload) {
      const slip = this.getSlip;

      //console.log("Slip", slip)
      //Ensure max 17 items in slip
      if (slip.length >= 17) {
        this.$bvToast.toast(translate("max_no_of_items_reached"), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 500,
          toaster: "b-toaster-top-center",
        });

        return;
      }

      // DO NOT ALLOW MORE BALL TO BE ADDED TO SLIP IF SLIP ALREADY HAS COMBINATION MORE THAN 6 balls
      if (payload.type === "BALLS") {
        if (slip.length) {
          if (slip.some((item) => item.type === "BALLS")) {
            if (slip[0]?.value?.length > 6) {
              return;
            }
          }

          // Check If extra games alrady played with one set of balls 
          if (slip.some((item) => item.type === "EXTRAS" || item.type === "EXTRAS-COLORS") && slip.some(
              (item) => item.type === "BALLS" && item.value?.length >= 6
            )) {

            return;
          }
        }
      }

      // DO NOT ALLOW TO MIX 6 COMBS WITH MORE THAN 6 balls
      if (payload.type === "BALLS" && payload.value.length > 6) {
        if (slip.length) {
          if (
            slip.every(
              (item) => item.type === "BALLS" && item.value?.length === 6
            )
          ) {
            return;
          }
        }
      }

      // Ensure to add only one extra bets
      if (payload.type === "EXTRAS") {
        if (slip.some((e) => e.id === payload.id)) {
          this.$store.dispatch(
            "setSlip",
            slip.filter((item) => item.id !== payload.id)
          );
          const updatedSlip = await this.getSlip;
          this.$store.dispatch("setSlip", [...updatedSlip, payload]);
          return;
        }
      }

      if (payload.type === "EXTRAS-COLORS") {
        // if payload is colors check is already in array , do not add it twice (id shortcodes TC : TOP COLORS, FVC : FIRST FIVE COLORS. LBC : LAST BALL COLORS )
        if (slip.some((e) => e.id === payload.id)) {
          return;
        } else {
          if (slip.some((e) => e.id === payload.id)) {
            this.$store.dispatch(
              "setSlip",
              slip.filter((item) => item.id !== payload.id)
            );
            this.$store.dispatch("setSlip", [...slip, payload]);
            return;
          }
        }
      }
      // ENSURE TO ADD ALLBALLS ONLY ONCE TO SLIP
      if (payload.type === "ALLBALLS") {
        if (slip.some((e) => e.type === payload.type)) {
          this.$bvToast.toast(
            translate(
              "same_numbers_combinations_cannot_be_added_multiple_times"
            ),
            {
              title: translate("notification"),
              variant: "danger",
              autoHideDelay: 500,
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }

        // Check If extra games alrady played 
        if (slip.some((item) => item.type === "EXTRAS" || item.type === "EXTRAS-COLORS")) {
          return;
        }

        if (slip.some((e) => e.type === "BALLS")) {
          this.$bvToast.toast(
            translate("all_colors_cant_combine_number_comb"),
            {
              title: translate("notification"),
              variant: "danger",
              autoHideDelay: 500,
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }
      }

      // ENSURE TO ADD MAX 10 BALLS COMBINATIONS OR 9 if ALLCOLORS ADDED
      if (payload.type === "BALLS") {
        if (slip.some((item) => item.type === "ALLBALLS")) {
          this.$bvToast.toast(
            translate("all_colors_cant_combine_number_comb"),
            {
              title: translate("notification"),
              variant: "danger",
              autoHideDelay: 500,
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }
        if (slip.filter((e) => e.type === payload.type).length > 7) {
          return;
        }

        // Ensure only one same ball number combination is added
        if (
          slip.some((row) => {
            if (Array.isArray(row.value)) {
              /* const intersection = row.value.map((ballObj) => ballObj.number).filter(element => payload.value.map((payloadBallObj) => payloadBallObj.number).includes(element));
            return intersection.length >= 6; */
              return (
                JSON.stringify(row.value.map((ballObj) => ballObj.number)) ===
                JSON.stringify(
                  payload.value.map((payloadBallObj) => payloadBallObj.number)
                )
              );
            }
          })
        ) {
          this.$bvToast.toast(
            translate(
              "same_numbers_combinations_cannot_be_added_multiple_times"
            ),
            {
              title: translate("notification"),
              variant: "danger",
              autoHideDelay: 500,
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }
      }
      this.$store.dispatch("setSlip", [...slip, payload]);

      this.clearSelectedBalls();
    },
    removeFromSlip(payload) {
      this.$store.dispatch(
        "setSlip",
        this.getSlip.filter((item) => item.id != payload)
      );

			// console.log("betting setSlip >>>>>>>>>>>>> ", this.getSlip.filter((item) => item.id != payload))
			this.getSlip.filter((item) => {
				// console.log("betting setSlip FILTER", item)
				return item.id != payload
			})
			$eventBus.$emit("minB", "noargs");
    },
    setExtraGamesCombinations(combs) {
      this.extraGamesCombinations = combs;
      this.setCombinations();
    },
    translate(word) {
      return translate(word);
    },
    confirmBuyingTicket() {
      const parsedPayload = JSON.parse(JSON.stringify(this.buyPayload));
      if (parsedPayload?.ticketAmount) {
        //this.$socket.emit("lb-buy-ticket", this.buyPayload);
        this.$store.dispatch("callBuyTicket", this.buyPayload);
      } else {
        this.$store.dispatch("setDisabledConfirm", false);
      }
    },
    buyTicket(buyData) {
      if (!this.getMainCombinations) {
        this.$bvToast.toast(translate(`chose_some_bets`), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        this.$store.dispatch("setQuickReplayDisabled", false);
        return;
      }

      if (this.getMainConfig) {
        if (
          Number(this.getMainConfig.TerminalCredit) < Number(buyData.betAmount)
        ) {
          this.$bvToast.toast(translate("insufficient_funds"), {
            title: translate("notification"),
            variant: "danger",
            autoHideDelay: 500,
            toaster: "b-toaster-top-center",
          });
          this.$store.dispatch("setQuickReplayDisabled", false);
          return;
        }
      }

      const extraValidation = this.validateExtras(buyData);
      if (extraValidation.status) {
        this.buyPayload = {
          ticketAmount: Number(buyData.betAmount),
          drawsCount: buyData.drawCount,
          first5Sum: buyData.firstFiveSum,
          ballParity: buyData.ballParity,
          ballSum: 0,
          firstBallParity: buyData.firstBallParity,
          firstballSum: buyData.firstBallSum,
          lastBallParity: buyData.lastBallParity,
          lastBallSum: buyData.lastBallSum,
          topColor: buyData.topColors,
          firstColor: buyData.firstColors,
          lastColor: buyData.lastColors,
        };

        let keyPair = {};
        let ballsSlipCounter = 2;
        let bSlipCounterWithoutAllBalls = 1;

        if (this.getSlip.some((item) => item.type === "ALLBALLS")) {
          this.getSlip.forEach((slipItem) => {
            if (slipItem.type === "ALLBALLS") {
              keyPair = {
                ...keyPair,
                selectedNumbers: slipItem.value.map((ball) => ball.number),
              };
            }
            if (slipItem.type === "BALLS") {
              keyPair[`selectedNumbers${ballsSlipCounter}`] =
                slipItem.value.map((ball) => ball.number);
              ballsSlipCounter++;
            }
          });
        } else {
          this.getSlip.forEach((slipItem) => {
            if (slipItem.type === "BALLS") {
              keyPair[
                `SelectedNumbers${
                  bSlipCounterWithoutAllBalls === 1
                    ? ""
                    : bSlipCounterWithoutAllBalls
                }`
              ] = slipItem.value.map((ball) => ball.number);
              bSlipCounterWithoutAllBalls++;
            }
          });
        }

        this.buyPayload = { ...this.buyPayload, ...keyPair };
        this.lastBuyPayload = this.buyPayload;

        this.$bvModal.show("confirmBuyModal");
        $eventBus.$emit("setTicketAmount", buyData.betAmount);
      } else {
        this.$bvToast.toast(extraValidation.message, {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        return;
      }
    },
    clearAll() {
			// console.log('CLEAR ALL BETTING');
      this.clearSelectedBalls();
			$eventBus.$emit("clearAllBets");
      this.buyPayload = {};
      this.$store.dispatch("setSlip", []);
    },
    validateExtras(buyData) {
      if ([0, 1, 2, 4].indexOf(buyData.topColors.length) === -1) {
        return {
          status: 0,
          message: translate("choose_1_2_4_common"),
        };
      }

      if ([0, 1, 2, 4].indexOf(buyData.firstColors.length) === -1) {
        return {
          status: 0,
          message: translate("choose_1_2_4_first"),
        };
      }

      if ([0, 1, 2, 4].indexOf(buyData.lastColors.length) === -1) {
        return { status: 0, message: translate("choose_1_2_4_last") };
      }

      return { status: true, message: "" };
    },

    setOneByOne(color) {
      return new Promise((resolve) => {
        this.selectColorsWithoutClear(color);
        setTimeout(() => {
          this.addBallsToSlip("dontClear").then(() => {
            resolve();
          });
        }, 10);
      });
    },

    setAllColors() {
     // Check If extra games alrady played 
     if (this.getSlip.some((item) => item.type === "EXTRAS" || item.type === "EXTRAS-COLORS")) {
        return;
      }
      // clear slip
      if (this.getSlip.length) {
        this.$store.dispatch("setSlip", []);
      }
      this.clearSelectedBalls();
      this.setOneByOne("red").then(() => {
        this.setOneByOne("green").then(() => {
          this.setOneByOne("blue").then(() => {
            this.setOneByOne("purple").then(() => {
              this.setOneByOne("brown").then(() => {
                this.setOneByOne("yellow").then(() => {
                  this.setOneByOne("orange").then(() => {
                    this.setOneByOne("silver").then(() => {
                      // deplaced make it selected 
                      Object.keys(this.balls).forEach((key) => {
                        this.balls[key].forEach((ball) => {
                          this.selectBalls(ball, true);
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
      return;
      // deplaced
      // Object.keys(this.balls).forEach((key) => {
      //   this.balls[key].forEach((ball) => {
      //     this.selectBalls(ball, true);
      //   });
      // });
    },
    setMainCombinations(slip) {
      let rules = {
        6: 1,
        7: 7,
        8: 28,
        9: 84,
        10: 210,
        48: 8,
      };

      let combs = this.getMainCombinations;
      combs = 0;

      if (slip && slip.length) {
        slip.forEach((item) => {
          if (item.type === "BALLS" || item.type === "ALLBALLS") {
            if (item && item.value && item.value.length) {
              if (item.value.length < 6) {
                combs = Number(combs);
              }
              if (item.value.length >= 6) {
                combs = Number(combs) + Number(rules[item.value.length]);
              }
            } else {
              console.error("NO ITEM VALUE");
            }
          }
        });

        this.$store.dispatch(
          "setMainCombinations",
          combs + Number(this.extraGamesCombinations)
        );
      } else {
        this.$store.dispatch("setMainCombinations", combs);
      }

      this.setStartingBetValueCombinations(slip);
    },
    setStartingBetValueCombinations(slip) {
      let rules = {
        6: 1,
        7: 1,
        8: 2.8,
        9: 8.4,
        10: 21.0,
        48: 4,
      };

      let combs = this.getMainCombinations;
      combs = 0;

      if (slip && slip.length) {
        slip.forEach((item) => {
          if (item.type === "BALLS" || item.type === "ALLBALLS") {
            if (item && item.value && item.value.length) {
              if (item.value.length < 6) {
                combs = Number(combs);
              }
              if (item.value.length >= 6) {
                combs = Number(combs) + Number(rules[item.value.length]);
              }
            } else {
              console.error("NO ITEM VALUE");
            }
          }
        });

        this.$store.dispatch(
          "setStartingBetCombinations",
          combs == 0 ? 1 : combs
        );
      } else {
        this.$store.dispatch(
          "setStartingBetCombinations",
          combs == 0 ? 1 : combs
        );
      }
    },
    setCombinations() {
      let rules = {
        6: 1,
        7: 7,
        8: 28,
        9: 84,
        10: 210,
        48: 8,
      };
      if (this.getSelectedBalls.length < 6) {
        this.$store.dispatch(
          "setInternalCombinations",
          Number(this.extraGamesCombinations)
        );
      }
      if (this.getSelectedBalls.length >= 6) {
        this.$store.dispatch(
          "setInternalCombinations",
          Number(rules[this.getSelectedBalls.length]) +
            Number(this.extraGamesCombinations)
        );
      }
    },
    clearSelectedBalls() {
      Object.keys(this.balls).forEach((key) => {
        this.balls[key] = this.balls[key].filter((arrBall) => {
          arrBall.selected = false;
          return this.balls[key];
        });
      });
      this.$store.dispatch("setSelectedBalls", []);
      // console.log('CLEAR THREAD') 
			setTimeout(()=> {$eventBus.$emit("minB", "noargs");},200)
    },
    randomSix(numbers) {
      this.clearSelectedBalls();
      numbers.forEach((number) => {
        Object.keys(this.balls).forEach((key) => {
          this.balls[key] = this.balls[key].filter((arrBall) => {
            if (Number(arrBall.number) === Number(number)) {
              this.selectBalls(arrBall);
            }
            return this.balls[key];
          });
        });
      });
    },
    async quickRandomSix(numbers) {
      this.clearSelectedBalls();
      numbers.forEach((number) => {
        Object.keys(this.balls).forEach((key) => {
          this.balls[key] = this.balls[key].filter((arrBall) => {
            if (Number(arrBall.number) === Number(number)) {
              this.selectBalls(arrBall);
            }
            return this.balls[key];
          });
        });
      });
      await this.getSelectedBalls;
      this.addBallsToSlip();
      await this.getSlip;
      $eventBus.$emit("buyQuickLuckyBalls");
    },
    asyncAllColorsSelect() {
      return new Promise((resolve) => {
        for (let number = 1; number <= this.maxNumber; number++) {
          Object.keys(this.balls).forEach((key) => {
            this.balls[key] = this.balls[key].filter((arrBall) => {
              if (Number(arrBall.number) === Number(number)) {
                this.selectBalls(arrBall, true);
              }
              return this.balls[key];
            });
          });
          if (number === 48) {
            resolve(true);
          }
        }
      });
    },
    asyncSelectBalls(data, x) {
      return new Promise((resolve) => {
        data[`numbers${x === 1 ? "" : x}`].forEach(async (number) => {
          Object.keys(this.balls).forEach((key, index) => {
            this.balls[key] = this.balls[key].filter((arrBall, filterIndex) => {
              if (Number(arrBall.number) === Number(number)) {
                this.selectBalls(arrBall);
              }
              if (index === 7 && filterIndex === 5) {
                resolve(true);
              }
              return this.balls[key];
            });
          });
        });
      });
    },
    selectBalls(ball, allColors = false) {
      if (allColors) {
        // insert ball in selected balls
        this.$store.dispatch("setSelectedBalls", [
          ...this.getSelectedBalls,
          {
            id: ball.id,
            number: ball.number,
            color: ball.color,
          },
        ]);
        // set current ball status selected to true
        this.balls[ball.color] = this.balls[ball.color].filter((arrBall) => {
          if (arrBall.color == ball.color) {
            ball.selected = true;
          }
          return this.balls[ball.color];
        });
      } else {
        let selectedBalls = this.getSelectedBalls;
        // if ball is already selected
        if (
          this.balls[ball.color].find((currentBall) => {
            return currentBall.number == ball.number;
          }).selected
        ) {
          // set that ball to selected false
          this.balls[ball.color] = this.balls[ball.color].filter((arrBall) => {
            if (arrBall.color == ball.color) {
              console.log("HARDCODE TEST ");
              // ORI // ball.selected = false;
            }
            return this.balls[ball.color];
          });

          this.$store.dispatch(
            "setSelectedBalls",
            selectedBalls.filter((loop) => loop.number !== ball.number)
          );
          // if ball is not selected
        } else {
          if (selectedBalls.length < this.maxNoOfSelectedBalls) {
            // insert ball in selected balls
            this.$store.dispatch("setSelectedBalls", [
              ...selectedBalls,
              {
                id: ball.id,
                number: ball.number,
                color: ball.color,
              },
            ]);
            // set current ball status selected to true
            this.balls[ball.color] = this.balls[ball.color].filter(
              (arrBall) => {
                if (arrBall.color == ball.color) {
                  ball.selected = true;
                }
                return this.balls[ball.color];
              }
            );
          }
        }
      }
    },
    selectColors(color) {
      this.clearSelectedBalls();
      this.balls[color].forEach((ball) => {
        this.selectBalls(ball);
      });
    },
    selectColorsWithoutClear(color) {
      // console.log("no clear");
      this.balls[color].forEach((ball) => {
        this.selectBalls(ball);
      });
    },
    fillGameBalls() {
      // fill red
      let redStaritngNumber = -7;
      const redBallColor = "red";
      for (let i = 1; i < 7; i++) {
        redStaritngNumber += 8;
        this.balls.red.push({
          id: redStaritngNumber,
          color: redBallColor,
          number: redStaritngNumber,
          selected: false,
        });
      }
      // fill green
      let greenStaritngNumber = -6;
      const greenBallColor = "green";
      for (let i = 1; i < 7; i++) {
        greenStaritngNumber += 8;
        this.balls.green.push({
          id: greenStaritngNumber,
          color: greenBallColor,
          number: greenStaritngNumber,
          selected: false,
        });
      }
      // blue balls
      let blueStaritngNumber = -5;
      const blueBallColor = "blue";
      for (let i = 1; i < 7; i++) {
        blueStaritngNumber += 8;
        this.balls.blue.push({
          id: blueStaritngNumber,
          color: blueBallColor,
          number: blueStaritngNumber,
          selected: false,
        });
      }
      // purple balls
      let purpleStaritngNumber = -4;
      const purpleBallColor = "purple";
      for (let i = 1; i < 7; i++) {
        purpleStaritngNumber += 8;
        this.balls.purple.push({
          id: purpleStaritngNumber,
          color: purpleBallColor,
          number: purpleStaritngNumber,
          selected: false,
        });
      }
      // brown balls
      let brownStaritngNumber = -3;
      const brownBallColor = "brown";
      for (let i = 1; i < 7; i++) {
        brownStaritngNumber += 8;
        this.balls.brown.push({
          id: brownStaritngNumber,
          color: brownBallColor,
          number: brownStaritngNumber,
          selected: false,
        });
      }
      // yellow balls
      let yellowStaritngNumber = -2;
      const yellowBallColor = "yellow";
      for (let i = 1; i < 7; i++) {
        yellowStaritngNumber += 8;
        this.balls.yellow.push({
          id: yellowStaritngNumber,
          color: yellowBallColor,
          number: yellowStaritngNumber,
          selected: false,
        });
      }
      // orange balls
      let orangeStaritngNumber = -1;
      const orangeBallColor = "orange";
      for (let i = 1; i < 7; i++) {
        orangeStaritngNumber += 8;
        this.balls.orange.push({
          id: orangeStaritngNumber,
          color: orangeBallColor,
          number: orangeStaritngNumber,
          selected: false,
        });
      }
      // silver balls
      let silverStaritngNumber = 0;
      const silverBallColor = "silver";
      for (let i = 1; i < 7; i++) {
        silverStaritngNumber += 8;
        this.balls.silver.push({
          id: silverStaritngNumber,
          color: silverBallColor,
          number: silverStaritngNumber,
          selected: false,
        });
      }
    },
  },
  mounted() {
    this.fillGameBalls();
    $eventBus.$on("confirmLuckyBallsTicketBuy", () => {
      this.confirmBuyingTicket();
    });
    $eventBus.$on("logoutClearAll", () => {
      this.clearAll();
    });
    $eventBus.$on("clearBetsFromBetBar", () => {
      this.clearAll();
    });
    $eventBus.$on("closeMenuClearBets", () => {
      this.clearAll();
    });
    $eventBus.$on("removeItemFromSlip", (item) => {
      this.removeFromSlip(item);
    });
    $eventBus.$on("setExtraBalls", (choice) => {
      this.extraBalls = choice;
    });
    $eventBus.$on("luckyBallsReplayTicket", async (data) => {
      this.$store.dispatch("setSlip", []);
      this.clearSelectedBalls();

      // If All Colors flag is set select all balls
      if (data.allColors) {
        await this.asyncAllColorsSelect();
        this.addBallsToSlip();
        this.clearSelectedBalls();
      } else {
        // select only selected numbers on ticket
        for (let x = 1; x <= 10; x++) {
          if (`numbers${x === 1 ? "" : x}` in data) {
            if (data[`numbers${x === 1 ? "" : x}`]) {
              if (data[`numbers${x === 1 ? "" : x}`].length >= 6) {
                await this.asyncSelectBalls(data, x);
                this.addBallsToSlip();
                this.clearSelectedBalls();
              }
            }
          }
        }
      }
      $eventBus.$emit("setLuckyBallsReplayTicketExtras", data);
    });
    this.$store.dispatch("setSlip", []);
  },
  watch: {
    $props: {
      handler() {
        let rProgress = this.resultTimer / (this.gameTimerResultMax / 100);
        let gProgress = this.gameTimer / (this.gameTimerMax / 100);
        this.resultProgress = (rProgress && rProgress > 0 && rProgress) || 0;
        this.gameProgress = (gProgress && gProgress > 0 && gProgress) || 0;
      },
      deep: true,
      immediate: true,
    },
    getSelectedBalls() {
      this.setCombinations();
    },
    getSlip() {
      this.setMainCombinations(this.getSlip);
    },
    getBoughtTicketResp() {
      $eventBus.$emit(`enableConfirmButton`, true);
      this.$store.dispatch("setQuickReplayDisabled", false);
      if (!this.getBoughtTicketResp) {
        this.$bvToast.toast(translate("api_buy_error"), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        return;
      }
      try {
        if ("Status" in this.getBoughtTicketResp) {
          if (this.getBoughtTicketResp.Status == 1) {

            try {
                // 1) da li smo uopšte u iframe-u
                if (window.parent && window.parent !== window) {

                    // 2) da li parent ima handler i funkciju
                    if (
                        window.parent.ticketIntegrationHandler &&
                        typeof window.parent.ticketIntegrationHandler.printTicket === 'function'
                    ) {
                        window.parent.ticketIntegrationHandler.printTicket(this.getBoughtTicketResp);
                    } else {
                        // Ne postoji wrapper - samo log (ili ništa)
                        console.log('ticketIntegrationHandler.printTicket not available in parent');
                    }
                }
            } catch (e) {
                // Cross-origin ili blokada - nemoj rušiti igru
                console.log('Cannot access parent ticketIntegrationHandler:', e && e.message ? e.message : e);
            }
            
            if (/electron=true/.test(window.location.href)) {
              window.parent.postMessage({
                  eventName: 'bought_ticket',
                  responseData: this.getBoughtTicketResp
                }, '*');
            }   

            //this.$socket.emit("get-terminal-config");
            this.$bvToast.toast(translate("ticket_bought_successfully"), {
              title: translate("notification"),
              variant: "success b-toaster-top-center",
              autoHideDelay: 3000,
              toaster: "b-toaster-top-center lb-buy",
            });
            this.clearAll();
          } else {
            console.error(this.getBoughtTicketResp.data);
            this.$bvToast.toast(this.getBoughtTicketResp.ErrorDescription, {
              title: translate("notification"),
              variant: "danger",
              autoHideDelay: 3000,
              toaster: "b-toaster-top-center",
            });
          }
        } else {
          console.error(this.getBoughtTicketResp);
          this.$bvToast.toast(translate("api_buy_error"), {
            title: translate("notification"),
            variant: "danger",
            autoHideDelay: 3000,
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        this.$bvToast.toast(translate("api_buy_error"), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
      }
    },
  },
  beforeDestroy() {
    $eventBus.$off(`clearAllBets`);
    $eventBus.$off("luckyBallsReplayTicket");
    $eventBus.$off("confirmLuckyBallsTicketBuy");
    $eventBus.$off("setExtraBalls");
    $eventBus.$off("clearBetsFromBetBar");
    $eventBus.$off("removeItemFromSlip");
    $eventBus.$off("closeMenuClearBets");
  },
};
</script>
